import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import apiService from '../services/api';
import { authHref, useSchoolBrand } from '../auth/schoolLink';
import { AuthScreen, BrandHeader, PoweredBy, errorText } from '../components/AuthChrome';
import '../styles/AuthScreen.css';

const ForgotPassword = () => {
  const brand = useSchoolBrand();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(() => String(searchParams.get('email') || '').trim());
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      await apiService.forgotPassword(email.trim());
      setSent(true);
    } catch (requestError) {
      setError(errorText(requestError, 'Could not send a reset link.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthScreen brand={brand}>
      <BrandHeader brand={brand} />
      <h1 className="auth-title">{sent ? 'Check your email' : 'Forgot password?'}</h1>
      <p className="auth-subtitle">
        {sent
          ? 'If an account with that email exists, we sent a link to reset your password.'
          : 'Enter the email on your account and we will send you a reset link.'}
      </p>

      {error ? <div className="auth-alert">{error}</div> : null}

      {sent ? null : (
        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <div className="auth-label-row">
              <label className="auth-label" htmlFor="forgot-email">
                Email address
              </label>
            </div>
            <input
              id="forgot-email"
              className="auth-input"
              type="email"
              name="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@email.com"
              autoComplete="email"
              required
            />
          </div>
          <button type="submit" className="auth-submit" disabled={loading}>
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}

      <p className="auth-footer">
        <Link to={authHref('/login', brand.schoolId)}>Back to log in</Link>
      </p>
      {brand.isSchool ? <PoweredBy /> : null}
    </AuthScreen>
  );
};

export default ForgotPassword;
